import { BackButton } from '../../components/BackButton';
import { Badge } from '../../components/Badge';
import { Button } from '../../components/Button';
import { ItemCard } from '../../components/ItemCard';
import { StickyActionBar } from '../../components/StickyActionBar';
import { formatCurrency } from '../../utils/formatCurrency';
import { roomUpgradeMetaText } from '../RoomUpgradeDialog';
import {
  Actions,
  ActionsSlot,
  BackRow,
  Heading,
  HeadingAccent,
  Panel,
  UpgradePrice,
} from './RoomUpgradeOfferPanel.styles';
import type { RoomUpgradeOfferPanelProps } from './RoomUpgradeOfferPanel.types';

export function RoomUpgradeOfferPanel({
  upgradeRoom,
  locale,
  onShowDetails,
  onSkip,
  onUpgrade,
  onBack,
  labels = {},
}: RoomUpgradeOfferPanelProps) {
  const {
    title = 'Upgrade.',
    titleAccent = 'A little extra, for a lot more luxury.',
    seeDetails = 'See details',
    upgradeFor = 'Upgrade for',
    forStay = 'for the stay',
    perNight = 'night',
    skip = 'No thanks',
    upgrade = 'Upgrade',
    noImage = 'No image',
    backAriaLabel = 'Go back',
  } = labels;

  const { name, imageUrl, urgencyText, priceDifference, priceDifferencePerNight } = upgradeRoom;
  const metaText = roomUpgradeMetaText(upgradeRoom);
  const differencePrice = priceDifferencePerNight ?? priceDifference;
  const differenceSuffix = priceDifferencePerNight ? `/ ${perNight}` : forStay;

  return (
    <Panel>
      {onBack && (
        <BackRow>
          <BackButton onClick={onBack} ariaLabel={backAriaLabel} />
        </BackRow>
      )}
      <Heading>
        {title} <HeadingAccent>{titleAccent}</HeadingAccent>
      </Heading>
      <ItemCard
        image={{ src: imageUrl ?? undefined, alt: name, placeholderLabel: noImage }}
        imageAspectRatio="16 / 10"
        title={name}
        boldTitle
        meta={metaText || undefined}
        imageBadge={urgencyText ? <Badge tone="sale">{urgencyText}</Badge> : undefined}
        action={{ label: seeDetails, onClick: onShowDetails }}
      />
      <UpgradePrice>
        {upgradeFor}{' '}
        <strong>
          + {formatCurrency(differencePrice.amount, differencePrice.currencyCode, { locale })}
        </strong>{' '}
        {differenceSuffix}
      </UpgradePrice>
      <ActionsSlot>
        <StickyActionBar>
          <Actions>
            <Button variant="secondary" fullWidth onClick={onSkip}>
              {skip}
            </Button>
            <Button variant="primary" fullWidth onClick={onUpgrade}>
              {upgrade}
            </Button>
          </Actions>
        </StickyActionBar>
      </ActionsSlot>
    </Panel>
  );
}
